import { hambergerToggle } from "./assets/js/modules/hamburgertoggle.js";
import { initPcNav } from "./assets/js/modules/pcNav.js";
import { scrollbarWidth } from "./assets/js/modules/scrollbarWidth.js";
import { OverlayScrollbarsSet } from "./assets/js/modules/OverlayScrollbarsSet.js";

// import { spNavDropToggle } from './assets/js/modules/spDropToggle.js';
import { pageTopBtnAction } from "./assets/js/modules/pagetopbtn-action.js";
import { cookie } from "./assets/js/modules/cookie.js";
import { loadingAni } from "./assets/js/modules/loadding-ani.js";
import { topSlider } from "./assets/js/modules/top-slider.js";

//スクロール時の動き
import { headerScrollAction01 } from "./assets/js/modules/headerScrollAction.js";

// フェードイン
import { fadeIn } from "./assets/js/modules/fadeInAni.js";
// textのアニメーションパターン

import { about } from "./assets/js/modules/about.js";
import { textAnimation01 } from "./assets/js/modules/textAni01.js";
import { textAnimation02 } from "./assets/js/modules/textAni02.js";
import { fadeColorImg } from "./assets/js/modules/fadeColorImg.js";
import { parallax } from "./assets/js/modules/parallax.js";
// import { changeSectionBgColor } from "./assets/js/modules/backgroundAni.js";
import { changeSectionBgColor02 } from "./assets/js/modules/backgroundAni02.js";
import { accordion } from "./assets/js/modules/accordion.js";
import { carSlider } from "./assets/js/modules/car-slider.js";
import { overlay } from "./assets/js/modules/overlay.js";

const $body = $("body");
// spNavDropToggle();
OverlayScrollbarsSet();

scrollbarWidth();
initPcNav();
hambergerToggle();
pageTopBtnAction();
cookie();
loadingAni();
headerScrollAction01();

//アニメーション
fadeIn();
textAnimation01(); //文字が横に伸びる動き
textAnimation02(); //文字の色が変わる
fadeColorImg();
parallax();
changeSectionBgColor02();
// changeSectionBgColor();
// Animation01();

if ($body.hasClass("top")) {
  topSlider();
}

accordion();

if ($body.hasClass("car")) {
  carSlider();
}

if ($body.hasClass("taxi")) {
  new ScrollHint(".js-scrollable");
}

if ($body.hasClass("about")) {
  about();
}

overlay();
